import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as S from './styles';
import { TabBar, TabButton } from '~/components';

export default function TeamSection({
  selectedMatch,
  optionSelected,
  tabMode,
  lineUp,
}) {
  const [tab, setTab] = useState('local');

  const changeTab = ({ value }) => {
    setTab(value);
  };

  return (
    <S.ContainerTeamContent tabMode={tabMode}>
      {tabMode && (
        <TabBar value={tab} onChange={changeTab}>
          <TabButton
            value="local"
            label={selectedMatch ? selectedMatch.homeTeam.nickname : '----'}
          />
          <TabButton
            value="away"
            label={selectedMatch ? selectedMatch.awayTeam.nickname : '----'}
          />
        </TabBar>
      )}
      {optionSelected === 1 && (
        <S.TeamBlockContent tabMode={tabMode}>
          {((tabMode && tab === 'local') || !tabMode) && (
            <S.TeamLocalBlock
              isLocal
              label={selectedMatch ? selectedMatch.homeTeam.nickname : '----'}
              bgImage="https://storageprodmzapp.blob.core.windows.net/assets/escudos/monocromo_oscuro/3_FC_BARCELONA.png"
              // La imagen de error debe venir directamente del backend REVISAR
              shield={
                selectedMatch
                  ? selectedMatch.homeTeam.shieldImageUrl
                  : 'https://storageprodmzapp.blob.core.windows.net/assets/escudos/no-club.png'
              }
              selectedMatch={selectedMatch}
              lineUp={lineUp}
            />
          )}
          {((tabMode && tab === 'away') || !tabMode) && (
            <S.TeamVisitorBlock
              label={selectedMatch ? selectedMatch.awayTeam.nickname : '----'}
              bgImage="https://storageprodmzapp.blob.core.windows.net/assets/escudos/monocromo_oscuro/9_REAL_SOCIEDAD.png?46"
              // La imagen de error debe venir directamente del backend REVISAR
              shield={
                selectedMatch
                  ? selectedMatch.awayTeam.shieldImageUrl
                  : 'https://storageprodmzapp.blob.core.windows.net/assets/escudos/no-club.png'
              }
              selectedMatch={selectedMatch}
              lineUp={lineUp}
            />
          )}
        </S.TeamBlockContent>
      )}
      {optionSelected === 2 && (
        <S.TeamBlockContent tabMode={tabMode}>
          {((tabMode && tab === 'local') || !tabMode) && (
            <S.TeamLocalBlock
              isLocal
              label={selectedMatch ? selectedMatch.homeTeam.nickname : '----'}
              bgImage="https://storageprodmzapp.blob.core.windows.net/assets/escudos/monocromo_oscuro/3_FC_BARCELONA.png"
              // La imagen de error debe venir directamente del backend REVISAR
              shield={
                selectedMatch
                  ? selectedMatch.homeTeam.shieldImageUrl
                  : 'https://storageprodmzapp.blob.core.windows.net/assets/escudos/no-club.png'
              }
              selectedMatch={selectedMatch}
              lineUp={lineUp}
            />
          )}
          {((tabMode && tab === 'away') || !tabMode) && (
            <S.TeamVisitorBlock
              label={selectedMatch ? selectedMatch.awayTeam.nickname : '----'}
              bgImage="https://storageprodmzapp.blob.core.windows.net/assets/escudos/monocromo_oscuro/9_REAL_SOCIEDAD.png?46"
              // La imagen de error debe venir directamente del backend REVISAR
              shield={
                selectedMatch
                  ? selectedMatch.awayTeam.shieldImageUrl
                  : 'https://storageprodmzapp.blob.core.windows.net/assets/escudos/no-club.png'
              }
              selectedMatch={selectedMatch}
              lineUp={lineUp}
            />
          )}
        </S.TeamBlockContent>
      )}
    </S.ContainerTeamContent>
  );
}

TeamSection.propTypes = {
  optionSelected: PropTypes.number,
  selectedMatch: PropTypes.object,
  lineUp: PropTypes.object,
  tabMode: PropTypes.bool,
};

TeamSection.defaultProps = {
  optionSelected: 0,
  selectedMatch: {},
  lineUp: {},
  tabMode: false,
};
